import __request__ from 'routing/request';
interface OnePasswordRequestImpl {
    readonly end_point: string;
    readonly api_token: unknown;
}
interface MediaType {
    readonly wildcard_subtype: boolean;
    readonly subtype: string;
    readonly wildcard_type: boolean;
    readonly type: string;
    readonly parameters: {
        readonly [_key: string]: string;
    };
}
interface OnePasswordCreateInputRequest {
    readonly content_type: string[];
    readonly end_point: string;
    readonly api_token: unknown;
    readonly name: string;
    readonly override_source: string;
    readonly store_full_message: boolean;
    readonly polling_interval: number;
    readonly enable_throttling: boolean;
}
/**
 * Validate input credentials
 */
export function checkCredentials(JSONbody: OnePasswordRequestImpl): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.onepassword.api.OnePasswordResource/onepassword/check_credentials', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
/**
 * Create a new 1Password Log Events input
 */
export function create(JSONbody: OnePasswordCreateInputRequest): Promise<MediaType> {
    return __request__('POST', '/plugins/org.graylog.enterprise.integrations.onepassword.api.OnePasswordResource/onepassword/inputs', JSONbody, {}, {
        'Accept': ['application/json']
    });
}
